import React from "react";
import { Progress } from "@/ui/components/ui/progress";
import { Badge } from "@/ui/components/ui/badge";
import { JobProgress, JobStatus } from "@/export/types/reports.ts";
import { useTranslation } from "react-i18next";
import { cn } from "@/ui/lib/utils";

interface ReportProgressProps {
  progress: JobProgress;
  status: JobStatus;
  className?: string;
}


const getStatusVariant = (status: JobStatus) => {
  switch (status) {
    case 'PENDING':
      return 'secondary';
    case 'RUNNING':
      return 'default';
    case 'SUCCESS':
      return 'default';
    case 'FAILED':
      return 'destructive';
    default:
      return 'secondary';
  }
};

export const ReportProgress: React.FC<ReportProgressProps> = ({
  progress,
  status,
  className,
}) => {
  const { t } = useTranslation("export");
  const isActive = status === 'PENDING' || status === 'RUNNING';
  const progressValue = isActive ? progress.percent : (status === 'SUCCESS' ? 100 : 0);

  return (
    <div className={cn("space-y-2", className)}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Badge variant={getStatusVariant(status)}>
            {t(`status.${status}`, { defaultValue: status })}
          </Badge>
          {isActive && (
            <span className="text-sm text-muted-foreground">
              {progress.stage}
            </span>
          )}
        </div>
        <span className="text-sm font-medium">
          {progressValue}%
        </span>
      </div>
      
      <Progress 
        value={progressValue} 
        className="h-2"
      />
      
      {isActive && (
        <div className="text-xs text-muted-foreground">
          {t("progress.steps", {
            current: progress.current,
            total: progress.total,
          })}
        </div>
      )}
    </div>
  );
};
